import { environment } from './../../environments/environment';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root'
})
export class RecuperarSenhaService {

  baseUrl = environment.baseUrl

  constructor(
    private http: HttpClient
  ) { }

  solicitarSenha(email:any){
    var url = `${this.baseUrl}password/forgot-password`
    return this.http.post(url, email)
  }

  enviarNovaSenha(senha:any){
    var url = `${this.baseUrl}password/reset`
    return this.http.post(url, senha)
  }

}
